import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withTranslation } from 'react-i18next';

class AlertDialog extends React.Component {
    state = {
        open: false,
        okDisabled: false,
        cancelDisabled: false,
        contentText: ""
    };

    doClose = (decision) => {
        this.decision = decision;
        this.setState({open: false});
    };

    finalize = () => {
        let decision = this.decision;
        this.props.spec[decision ? 'resolve' : 'reject'](decision);
    };

    componentDidMount() {
        let spec = this.props.spec;
        let t = this.props.t;
        spec.close = () => {
            this.doClose(false);
        };
        spec.setState = (newState) => {
            Object.assign(spec, newState);
            this.setState(newState);
        };
        this.setState({open: true, content: spec.content, contentText: spec.contentText, title: spec.title || t("dialog_confirm")});
    }

    handleClose = (decision) => () => {
        let maybePromise = null;
        if (decision) {
            if (this.props.spec.ok) {
                maybePromise = this.props.spec.ok();
            }

            if (this.props.spec.ok === false || maybePromise === false) {
                return;
            }

        } else {
            if (this.props.spec.cancel) {
                maybePromise = this.props.spec.cancel();
            }
        }


        if (maybePromise) {
            maybePromise.then(() => this.doClose(decision));
        } else {
            this.doClose(decision);
        }
    };

    render() {
        let spec = this.props.spec;
        let state = this.state;
        let t = this.props.t;
        return (
            <div>
                <Dialog
                    onExited={this.finalize}
                    open={this.state.open}
                    onClose={() => this.doClose(false)}
                >
                    <DialogTitle>{state.title}</DialogTitle>
                    <DialogContent>
                        {state.content ? state.content : <DialogContentText>
                            {state.contentText || t("dialog_proceed")}
                        </DialogContentText>}
                    </DialogContent>
                    <DialogActions>
                        {spec.cancelText !== false ? <Button disabled={state.cancelDisabled} onClick={this.handleClose(false)} color="secondary">
                            {spec.cancelText || t("dialog_cancel")}
                        </Button> : null}
                        {spec.okText !== false ? <Button disabled={state.okDisabled} onClick={this.handleClose(true)} color="primary" autoFocus>
                            {spec.okText || t("dialog_ok")}
                        </Button> : null}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

AlertDialog = withTranslation()(AlertDialog);
export default AlertDialog;